import React from 'react';

interface PieChartProps {
  data: { name: string; value: number }[];
  colors?: string[];
  width?: number | string;
  height?: number | string;
}

const PieChartComponent: React.FC<PieChartProps> = ({
  data,
  colors = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'],
  width = 260,
  height = 260,
}) => {
  const total = data.reduce((sum, item) => sum + item.value, 0) || 1;

  // Build SVG path arcs for each slice
  let cumulative = 0;
  const radius = 120;
  const center = 140;

  const slices = data.map((item, index) => {
    const value = item.value;
    const startAngle = (cumulative / total) * Math.PI * 2;
    const endAngle = ((cumulative + value) / total) * Math.PI * 2;
    cumulative += value;

    const x1 = center + radius * Math.cos(startAngle - Math.PI / 2);
    const y1 = center + radius * Math.sin(startAngle - Math.PI / 2);
    const x2 = center + radius * Math.cos(endAngle - Math.PI / 2);
    const y2 = center + radius * Math.sin(endAngle - Math.PI / 2);
    const largeArcFlag = endAngle - startAngle > Math.PI ? 1 : 0;

    const d = [
      `M ${center} ${center}`,
      `L ${x1} ${y1}`,
      `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}`,
      'Z',
    ].join(' ');

    return (
      <path
        key={item.name}
        d={d}
        fill={colors[index % colors.length]}
        stroke="#ffffff"
        strokeWidth={1}
      />
    );
  });

  return (
    <div
      style={{
        width,
        height,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <svg width={center * 2} height={center * 2} viewBox={`0 0 ${center * 2} ${center * 2}`}>
        {slices}
        {/* Inner circle to create donut effect */}
        <circle cx={center} cy={center} r={radius * 0.6} fill="#ffffff" />
      </svg>
    </div>
  );
};

export default PieChartComponent;